module.exports = __webpack_public_path__ + "static/media/key-orange.adae54e1.svg";